import { SeedingReportFormGroup } from './seeding-report-form-group';
import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
var SeedingReportFormComponent = /** @class */ (function () {
    function SeedingReportFormComponent(options, loadingService, alertService, reportingService, reportWriterService) {
        var _this = this;
        this.loadingService = loadingService;
        this.alertService = alertService;
        this.reportingService = reportingService;
        this.reportWriterService = reportWriterService;
        this.rootForm = new SeedingReportFormGroup();
        options.crops.subscribe(function (c) { return _this.crops = c.sort(AlphabeticalNamedSorter); });
        options.flatTypes.subscribe(function (f) { return _this.flatTypes = f.sort(AlphabeticalNamedSorter); });
        options.substrates.subscribe(function (s) { return _this.substrates = s.sort(AlphabeticalNamedSorter); });
    }
    Object.defineProperty(SeedingReportFormComponent.prototype, "startDateFormControl", {
        get: function () {
            return this.rootForm.startDateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormComponent.prototype, "endDateFormControl", {
        get: function () {
            return this.rootForm.endDateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormComponent.prototype, "cropFormControl", {
        get: function () {
            return this.rootForm.cropFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormComponent.prototype, "containerTypeFormControl", {
        get: function () {
            return this.rootForm.containerTypeFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SeedingReportFormComponent.prototype, "substrateFormControl", {
        get: function () {
            return this.rootForm.substrateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    SeedingReportFormComponent.prototype.ngOnInit = function () {
    };
    SeedingReportFormComponent.prototype.generateReport = function () {
        var _this = this;
        this.loadingService.setMessage('Generating seeding report...');
        this.reportingService.getSeedingReport({
            containerTypeId: this.containerTypeFormControl.value,
            cropId: this.cropFormControl.value,
            endDate: this.endDateFormControl.value,
            startDate: this.startDateFormControl.value,
            substrateId: this.substrateFormControl.value
        })
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (file) { return _this.reportWriterService.save(file); }, function (error) { return _this.alertService.error('Error generating seeding report.'); });
    };
    return SeedingReportFormComponent;
}());
export { SeedingReportFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/seeding-report-form/seeding-report-form.component.ts.pre-build-optimizer.js